import axios, {AxiosResponse} from 'axios'

// List Campus
const campusList = async ({params}) => {
  const response = await axios.get('/api/campus/list', params)
  return response.data
}

// Create Or Update new Campus
const campusCreate = async ({data}) => {
  await axios.post('/api/campus/store', data)
}

// Edit Campus
const campusEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/campus/edit/${id}`)
  return response.data
}

// Delete Campus
const campusDelete = async (id: string) => {
  await axios.get(`/api/campus/destroy/${id}`)
}

const campusView = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/campus/show/${id}`)
  return response.data
}

// List CampusManager
const campusManagerList = async ({params}) => {
  const response = await axios.get('/api/campus-manager/list', params)
  return response.data
}

// Create Or Update new CampusManager
const campusManagerCreate = async ({data}) => {
  await axios.post('/api/campus-manager/store', data)
}

// Edit CampusManager
const campusManagerEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/campus-manager/edit/${id}`)
  return response.data
}

// Active CampusManager
const campusManagerActive = async (id: string) => {
  await axios.get(`/api/campus-manager/active/${id}`)
}

// Inactive CampusManager
const campusManagerInactive = async (id: string) => {
  await axios.get(`/api/campus-manager/inactive/${id}`)
}

// List CampusCurrency
const campusCurrencyList = async ({params}) => {
  const response = await axios.get('/api/campus-currency/list', params)
  return response.data
}

// Create Or Update new CampusCurrency
const campusCurrencyCreate = async ({data}) => {
  await axios.post('/api/campus-currency/store', data)
}

// Edit CampusCurrency
const campusCurrencyEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/campus-currency/edit/${id}`)
  return response.data
}

// Delete CampusCurrency
const campusCurrencyDelete = async (id: string) => {
  await axios.get(`/api/campus-currency/destroy/${id}`)
}

// List CampusGrading
const campusGradingList = async () => {
  const response = await axios.get('/api/campus-grading/list')
  return response.data
}

// Create Or Update new CampusGrading
const campusGradingCreate = async ({data}) => {
  await axios.post('/api/campus-grading/store', data)
}

// Edit CampusGrading
const campusGradingEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/campus-grading/edit/${id}`)
  return response.data
}

// Delete CampusGrading
const campusGradingDelete = async (id: string) => {
  await axios.get(`/api/campus-grading/destroy/${id}`)
}

// List CampusBank
const campusBankList = async ({params}) => {
  const response = await axios.get('/api/campus-bank/list', params)
  return response.data
}

// Create Or Update new CampusBank
const campusBankCreate = async ({data}) => {
  await axios.post('/api/campus-bank/store', data)
}

// Edit CampusBank
const campusBankEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/campus-bank/edit/${id}`)
  return response.data
}

// Delete CampusBank
const campusBankDelete = async (id: string) => {
  await axios.get(`/api/campus-bank/destroy/${id}`)
}

const campusService = {
  campusView,
  campusList,
  campusCreate,
  campusEdit,
  campusDelete,
  campusManagerList,
  campusManagerCreate,
  campusManagerEdit,
  campusManagerActive,
  campusManagerInactive,
  campusCurrencyList,
  campusCurrencyCreate,
  campusCurrencyEdit,
  campusCurrencyDelete,
  campusGradingList,
  campusGradingCreate,
  campusGradingEdit,
  campusGradingDelete,
  campusBankList,
  campusBankCreate,
  campusBankEdit,
  campusBankDelete,
}

export default campusService
